import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import JuicesSection from "@/components/JuicesSection";
import HowToOrder from "@/components/HowToOrder";
import FreeRecipes from "@/components/FreeRecipes";
import RecipeModal from "@/components/RecipeModal";
import WhyColdPressed from "@/components/WhyColdPressed";
import EmailSignup from "@/components/EmailSignup";
import Footer from "@/components/Footer";

const Landing = () => {
  const [juices, setJuices] = useState([]);
  const [recipes, setRecipes] = useState([]);
  const [activeRecipe, setActiveRecipe] = useState(null);

  useEffect(() => {
    api.get("/juices").then((r) => setJuices(r.data)).catch(() => {});
    api.get("/recipes").then((r) => setRecipes(r.data)).catch(() => {});
  }, []);

  const heroImage = juices.find((j) => j.available)?.image_url || juices[0]?.image_url;

  return (
    <div className="relative min-h-screen bg-[#FFF8F0]">
      <Navbar />
      <Hero heroImage={heroImage} />
      <EditorialMarquee />
      <JuicesSection juices={juices} />
      <HowToOrder />
      <FreeRecipes recipes={recipes} onOpen={setActiveRecipe} />
      <WhyColdPressed />
      <EmailSignup />
      <Footer />
      <RecipeModal recipe={activeRecipe} onClose={() => setActiveRecipe(null)} />
    </div>
  );
};

export default Landing;
